import { Component, inject, input } from '@angular/core';
import { rxResource } from '@angular/core/rxjs-interop';
import { KENDO_GRID } from '@progress/kendo-angular-grid';
import { KENDO_LISTVIEW } from '@progress/kendo-angular-listview';
import { AbstractGridComponent } from '@unity/abstract/abstract-grid.component';
import { FormScheduleDetailedDto, FormSchedulesClient } from '@unity/clients';
import { TypedDirective } from '@unity/directives/typed.directive';
import { DateTimezonePipe } from '@unity/pipes/date-timezone.pipe';
import { GridSharedComponent } from '@unity/shared/composed/grid-shared/grid-shared.component';
import { ChipWorkflowStateSharedComponent } from '@unity/shared/presentation/chip-workflow-state-shared/chip-workflow-state-shared.component';
import { LinkGridcellSharedComponent } from '@unity/shared/presentation/link-gridcell-shared/link-gridcell-shared.component';
import { SortConfig } from '@unity/utils/types';

@Component({
  selector: 'unity-grid-agreement-form-shared',
  standalone: true,
  imports: [
    KENDO_GRID,
    KENDO_LISTVIEW,
    DateTimezonePipe,
    GridSharedComponent,
    LinkGridcellSharedComponent,
    ChipWorkflowStateSharedComponent,
    TypedDirective,
  ],
  templateUrl: './grid-agreement-form-shared.component.html',
  styleUrl: './grid-agreement-form-shared.component.scss',
})
export class GridAgreementFormSharedComponent extends AbstractGridComponent<FormScheduleDetailedDto> {
  private readonly formSchedulesClient = inject(FormSchedulesClient);

  protected readonly resource = rxResource({
    params: () => {
      const query = this.$gridifyQuery();
      const agreementId = this.$agreementId();
      return query && agreementId ? { query, agreementId } : undefined;
    },
    stream: ({ params: { agreementId, query } }) =>
      this.formSchedulesClient.getAllForAgreementAsDetailed(agreementId, query.page, query.pageSize, query.orderBy, query.filter),
  });

  public readonly $agreementId = input.required<number>({ alias: 'agreementId' });

  protected defaultSort: SortConfig[] = [
    {
      field: 'created_dt',
      dir: 'desc',
    },
  ];
}
